import { getSupportedLocale } from '@ms/yammer-i18n';

import { useI18nStore } from '../../state/i18nStore';
import type { Locale } from '../../state/types';

type SetLocale = (locale: Locale) => void;
export const setLocale: SetLocale = (locale) => {
  const supportedLocale = getSupportedLocale(locale);

  useI18nStore.setState((state) => ({
    previousLocale: state.currentLocale,
    currentLocale: supportedLocale,
  }));
};

type SetLocaleFromBrowser = (overrideLocale?: Locale) => void;
export const setLocaleFromBrowser: SetLocaleFromBrowser = (overrideLocale) => {
  const currentLocale = useI18nStore.getState().currentLocale;
  if (currentLocale) {
    return;
  }

  const locale = overrideLocale ?? window.navigator.language;
  setLocale(locale);
};
